// FootingShapesDialog.tsx — Footing haunch geometry (fsvar)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { useShallowStore } from '../store/useStore';
import type { FsVar, FsData } from '../types/panelvar';

const FIELDS = [
  { key: 'mark',   label: 'Mark',   type: 'text'   as const },
  { key: 'x',      label: 'X',      type: 'number' as const, unit: '"', min: 0 },
  { key: 'width',  label: 'Width',  type: 'number' as const, unit: '"', min: 0 },
  { key: 'height', label: 'Height', type: 'number' as const, unit: '"', min: 0 },
];

export default function FootingShapesDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = useState<FsVar>(panel?.fsvar ?? []);
  if (!panel) return null;

  return (
    <DialogBase title="Footing Shapes (2 max)" onOk={() => updatePanel(panel.id, { fsvar: slots })}>
      <SlotEditor<FsData>
        slots={slots}
        fields={FIELDS}
        maxSlots={2}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', x: 0, width: 0, height: 0 })}
        label="Footing"
      />
    </DialogBase>
  );
}
